import React from 'react'
import PublicPageSF from '../../templates/PublicPageSF'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import ContentUI from '../../widgets/output/ContentUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'

const PrivacyPageUI = ({context, privacy, messageList}) =>
  <PublicPageSF context={context} className='pg_privacy' backLink='/'
    messageList={messageList} headerMessageKey='c_privacy'
    centered={!privacy}
  >
    {
      !privacy &&
      <SpinnerComponentUI />
    }
    {
      privacy &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/'
          messageList={messageList} titleMessageKey='c_privacy'
        />
        <ContentUI context={context} content={privacy} />
      </div>
    }
  </PublicPageSF>

export default PrivacyPageUI
